import { DashboardPinnedItem } from '../types';

/**
 * Mock response for the Dashboard Pinned Items API — study entities only.
 *
 * Contains 9 items with `entity_type: 'study'` covering all available status
 * values (`draft`, `pending`, `pre-review`, `review`, `complete`, `to-do`) to
 * support full UI state coverage in tests. Items 1–4 are anchored to real SBX
 * API data; items 5–9 are fabricated to fill remaining status variants.
 */
export const PINNED_STUDIES_MOCK: DashboardPinnedItem = {
  count: 9,
  items: [
    {
      pinned_id: '92fc6ae9-c3d3-4689-8b2e-45740c7b8cf6',
      entity: {
        id: '6d30eba3-7029-4d68-86bb-22091f291d3b',
        name: 'Final testing SS0',
        status: 'draft',
        entity_type: 'study',
        pi_name: null,
      },
      related_study: {
        sponsor_protocol_id: 'FT-NEU-042',
        study_name: 'Final testing SS0',
        sponsor_name: 'NeuraTech Labs',
        source_tracking_id: 'WCG-2026-003',
      },
      number_of_sites: 1,
      ordinal: 1,
      pinned_at: '2026-07-22T12:24:45.054158',
    },
    {
      pinned_id: 'e795a443-5923-4951-911f-3f667268d04a',
      entity: {
        id: 'dde994b8-6d51-4e59-9f16-b536510c8a2e',
        name: 'Invite B3',
        status: 'draft',
        entity_type: 'study',
        pi_name: null,
      },
      related_study: {
        sponsor_protocol_id: 'IB-IMM-077',
        study_name: 'Invite B3',
        sponsor_name: 'ImmunoBio Corp',
        source_tracking_id: 'WCG-2026-002',
      },
      number_of_sites: 1,
      ordinal: 2,
      pinned_at: '2026-07-22T14:14:47.661515',
    },
    {
      pinned_id: 'cb545f99-f882-41e0-a678-0a531e9b2618',
      entity: {
        id: '3e0358b3-cda1-428e-8801-cd243a8b35b3',
        name: 'Ext Integration Mock Study (GLOBAL)',
        status: 'draft',
        entity_type: 'study',
        pi_name: null,
      },
      related_study: {
        sponsor_protocol_id: 'Mock Study IRBNet GLOBAL',
        study_name: 'Ext Integration Mock Study (GLOBAL)',
        sponsor_name: 'IRBNet Global',
        source_tracking_id: null,
      },
      number_of_sites: 0,
      ordinal: 3,
      pinned_at: '2026-07-23T13:51:41.130905',
    },
    {
      pinned_id: '9cc9bce9-8fab-43b9-b233-1763f2a24960',
      entity: {
        id: '03a7adc5-7ccc-4054-8c68-041400696ad2',
        name: 'Pinned Study 001',
        status: 'pending',
        entity_type: 'study',
        pi_name: null,
      },
      related_study: {
        sponsor_protocol_id: 'SM-PIN-001',
        study_name: 'Pinned Study 001',
        sponsor_name: 'BioSynth Pharma',
        source_tracking_id: 'WCG-2026-001',
      },
      number_of_sites: 2,
      ordinal: 4,
      pinned_at: '2026-07-24T09:34:45.114547',
    },
    {
      pinned_id: 'a1b2c3d4-e5f6-4a7b-8c9d-0e1f2a3b4c5d',
      entity: {
        id: 'f1e2d3c4-b5a6-4978-8c7b-6a5b4c3d2e1f',
        name: 'Oncology Phase III Trial',
        status: 'pre-review',
        entity_type: 'study',
        pi_name: null,
      },
      related_study: {
        sponsor_protocol_id: 'ONC-PH3-015',
        study_name: 'Oncology Phase III Trial',
        sponsor_name: 'GenomeX Therapeutics',
        source_tracking_id: 'WCG-2026-005',
      },
      number_of_sites: 4,
      ordinal: 5,
      pinned_at: '2026-07-20T08:00:00.000000',
    },
    {
      pinned_id: 'b2c3d4e5-f6a7-4b8c-9d0e-1f2a3b4c5d6e',
      entity: {
        id: 'e2d3c4b5-a6f7-4879-9c8b-7b6c5d4e3f2a',
        name: 'Cardiology Outcomes Study',
        status: 'review',
        entity_type: 'study',
        pi_name: null,
      },
      related_study: {
        sponsor_protocol_id: 'CARD-OUT-031',
        study_name: 'Cardiology Outcomes Study',
        sponsor_name: 'CardioVentis Inc',
        source_tracking_id: 'WCG-2026-006',
      },
      number_of_sites: 7,
      ordinal: 6,
      pinned_at: '2026-07-20T09:15:00.000000',
    },
    {
      pinned_id: 'c3d4e5f6-a7b8-4c9d-0e1f-2a3b4c5d6e7f',
      entity: {
        id: 'd3c4b5a6-f7e8-4970-8d9c-8c7d6e5f4a3b',
        name: 'Rare Metabolic Disorder Registry',
        status: 'complete',
        entity_type: 'study',
        pi_name: null,
      },
      related_study: {
        sponsor_protocol_id: 'RMD-REG-009',
        study_name: 'Rare Metabolic Disorder Registry',
        sponsor_name: 'OrphanCare Global',
        source_tracking_id: 'WCG-2026-007',
      },
      number_of_sites: 12,
      ordinal: 7,
      pinned_at: '2026-07-21T10:30:00.000000',
    },
    {
      pinned_id: 'd4e5f6a7-b8c9-4d0e-1f2a-3b4c5d6e7f8a',
      entity: {
        id: 'c4b5a6f7-e8d9-4071-9e0d-9d8e7f6a5b4c',
        name: 'Pediatric CNS Trial',
        status: 'to-do',
        entity_type: 'study',
        pi_name: null,
      },
      related_study: {
        sponsor_protocol_id: 'PED-CNS-022',
        study_name: 'Pediatric CNS Trial',
        sponsor_name: 'NeuroGen Biopharma',
        source_tracking_id: 'WCG-2026-008',
      },
      number_of_sites: 0,
      ordinal: 8,
      pinned_at: '2026-07-21T11:45:00.000000',
    },
    {
      pinned_id: 'e5f6a7b8-c9d0-4e1f-2a3b-4c5d6e7f8a9b',
      entity: {
        id: 'b5a6f7e8-d9c0-4172-8f1e-0e9f8a7b6c5d',
        name: 'Dermatology Long-Term Safety',
        status: 'pre-review',
        entity_type: 'study',
        pi_name: null,
      },
      related_study: {
        sponsor_protocol_id: 'DERM-LTS-044',
        study_name: 'Dermatology Long-Term Safety',
        sponsor_name: 'SkinSci Corp',
        source_tracking_id: 'WCG-2026-009',
      },
      number_of_sites: 3,
      ordinal: 9,
      pinned_at: '2026-07-21T13:00:00.000000',
    },
  ],
};

/**
 * Mock response for the Dashboard Pinned Items API — site entities only.
 *
 * Contains 9 items with `entity_type: 'site'` covering all available status
 * values (`draft`, `pending`, `pre-review`, `review`, `complete`, `to-do`).
 * `number_of_sites` is `null` for all site entries as returned by the API.
 * Items 1–3 are anchored to real SBX API data; items 4–9 are fabricated.
 */
export const PINNED_SITES_MOCK: DashboardPinnedItem = {
  count: 9,
  items: [
    {
      pinned_id: '73a6c091-46a4-4f7f-b858-1a3f3abdc075',
      entity: {
        id: '6708de70-149d-4986-951c-23144f9dd30a',
        name: 'Pending',
        status: 'draft',
        entity_type: 'site',
        pi_name: 'Pending',
      },
      related_study: {
        sponsor_protocol_id: 'PW-KAZ-004',
        study_name: 'Power of Akuma',
        sponsor_name: 'Kaazumi',
        source_tracking_id: 'WCG-2026-004',
      },
      number_of_sites: null,
      ordinal: 1,
      pinned_at: '2026-07-22T12:24:45.054158',
    },
    {
      pinned_id: '3023fb88-db1b-482b-bb98-d98076589352',
      entity: {
        id: '5ffbd0eb-02fe-43f6-93e3-3a6b99e36bec',
        name: 'Pending',
        status: 'draft',
        entity_type: 'site',
        pi_name: 'Pending',
      },
      related_study: {
        sponsor_protocol_id: 'FT-NEU-042',
        study_name: 'Final testing SS0',
        sponsor_name: 'NeuraTech Labs',
        source_tracking_id: 'WCG-2026-003',
      },
      number_of_sites: null,
      ordinal: 2,
      pinned_at: '2026-07-22T12:24:45.054158',
    },
    {
      pinned_id: '08cb45e0-86fd-46c5-b89d-6b63313ee59f',
      entity: {
        id: 'a9c96425-11b4-4e9c-9fd1-78e2b589eca6',
        name: 'Jain, Anuv',
        status: 'pending',
        entity_type: 'site',
        pi_name: 'Jain, Anuv',
      },
      related_study: {
        sponsor_protocol_id: 'SM-PIN-001',
        study_name: 'Pinned Study 001',
        sponsor_name: 'BioSynth Pharma',
        source_tracking_id: 'WCG-2026-001',
      },
      number_of_sites: null,
      ordinal: 3,
      pinned_at: '2026-07-24T09:46:17.834097',
    },
    {
      pinned_id: 'f6a7b8c9-d0e1-4f2a-3b4c-5d6e7f8a9b0c',
      entity: {
        id: 'a6f7e8d9-c0b1-4273-8a2f-1f0a9b8c7d6e',
        name: 'Smith, Robert',
        status: 'pre-review',
        entity_type: 'site',
        pi_name: 'Smith, Robert',
      },
      related_study: {
        sponsor_protocol_id: 'ONC-PH3-015',
        study_name: 'Oncology Phase III Trial',
        sponsor_name: 'GenomeX Therapeutics',
        source_tracking_id: 'WCG-2026-005',
      },
      number_of_sites: null,
      ordinal: 4,
      pinned_at: '2026-07-20T08:05:00.000000',
    },
    {
      pinned_id: 'a7b8c9d0-e1f2-4a3b-4c5d-6e7f8a9b0c1d',
      entity: {
        id: 'f7e8d9c0-b1a2-4374-8b3a-2a1b0c9d8e7f',
        name: 'Chen, Wei',
        status: 'review',
        entity_type: 'site',
        pi_name: 'Chen, Wei',
      },
      related_study: {
        sponsor_protocol_id: 'CARD-OUT-031',
        study_name: 'Cardiology Outcomes Study',
        sponsor_name: 'CardioVentis Inc',
        source_tracking_id: 'WCG-2026-006',
      },
      number_of_sites: null,
      ordinal: 5,
      pinned_at: '2026-07-20T09:20:00.000000',
    },
    {
      pinned_id: 'b8c9d0e1-f2a3-4b4c-5d6e-7f8a9b0c1d2e',
      entity: {
        id: 'e8d9c0b1-a2f3-4475-8c4b-3b2c1d0e9f8a',
        name: 'Patel, Ananya',
        status: 'complete',
        entity_type: 'site',
        pi_name: 'Patel, Ananya',
      },
      related_study: {
        sponsor_protocol_id: 'RMD-REG-009',
        study_name: 'Rare Metabolic Disorder Registry',
        sponsor_name: 'OrphanCare Global',
        source_tracking_id: 'WCG-2026-007',
      },
      number_of_sites: null,
      ordinal: 6,
      pinned_at: '2026-07-21T10:35:00.000000',
    },
    {
      pinned_id: 'c9d0e1f2-a3b4-4c5d-6e7f-8a9b0c1d2e3f',
      entity: {
        id: 'd9c0b1a2-f3e4-4576-8d5c-4c3d2e1f0a9b',
        name: 'Torres, Maria',
        status: 'to-do',
        entity_type: 'site',
        pi_name: 'Torres, Maria',
      },
      related_study: {
        sponsor_protocol_id: 'PED-CNS-022',
        study_name: 'Pediatric CNS Trial',
        sponsor_name: 'NeuroGen Biopharma',
        source_tracking_id: 'WCG-2026-008',
      },
      number_of_sites: null,
      ordinal: 7,
      pinned_at: '2026-07-21T11:50:00.000000',
    },
    {
      pinned_id: 'd0e1f2a3-b4c5-4d6e-7f8a-9b0c1d2e3f4a',
      entity: {
        id: 'c0b1a2f3-e4d5-4677-8e6d-5d4e3f2a1b0c',
        name: 'Nguyen, James',
        status: 'draft',
        entity_type: 'site',
        pi_name: 'Nguyen, James',
      },
      related_study: {
        sponsor_protocol_id: 'DERM-LTS-044',
        study_name: 'Dermatology Long-Term Safety',
        sponsor_name: 'SkinSci Corp',
        source_tracking_id: 'WCG-2026-009',
      },
      number_of_sites: null,
      ordinal: 8,
      pinned_at: '2026-07-21T13:05:00.000000',
    },
    {
      pinned_id: 'e1f2a3b4-c5d6-4e7f-8a9b-0c1d2e3f4a5b',
      entity: {
        id: 'b1a2f3e4-d5c6-4778-8f7e-6e5f4a3b2c1d',
        name: 'Williams, Sarah',
        status: 'pending',
        entity_type: 'site',
        pi_name: 'Williams, Sarah',
      },
      related_study: {
        sponsor_protocol_id: 'IB-IMM-077',
        study_name: 'Invite B3',
        sponsor_name: 'ImmunoBio Corp',
        source_tracking_id: 'WCG-2026-002',
      },
      number_of_sites: null,
      ordinal: 9,
      pinned_at: '2026-07-22T08:30:00.000000',
    },
  ],
};
